import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 35.721 39.16",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Sideinnstillinger",
		transform: "translate(-1413 -541.999)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "settings_FILL1_wght300_GRAD0_opsz48",
			d: "M112.621,213.653l-.42-2.793a6.183,6.183,0,0,1-1.027-.473,5.711,5.711,0,0,1-.949-.657l-2.6,1.183-1.856-3.282,2.348-1.728a4.629,4.629,0,0,1-.067-.534q-.021-.289-.021-.534t.021-.525q.021-.289.067-.561l-2.348-1.737,1.856-3.255,2.589,1.165a7.125,7.125,0,0,1,.958-.652,4.992,4.992,0,0,1,1.018-.454l.429-2.816H116.3l.42,2.8a7.683,7.683,0,0,1,1.026.47,4.856,4.856,0,0,1,.924.65l2.633-1.165,1.847,3.255-2.383,1.726a3.294,3.294,0,0,1,.08.557q.016.28.016.531t-.021.515a5.181,5.181,0,0,1-.076.568l2.374,1.722-1.856,3.282-2.616-1.192a7.753,7.753,0,0,1-.937.673,4.17,4.17,0,0,1-1.012.457l-.42,2.8Zm1.815-6.209a2.609,2.609,0,1,0-1.851-.762A2.525,2.525,0,0,0,114.436,207.444Z",
			transform: "translate(1325.566 367.507)"
		}), /* @__PURE__ */ _jsx("path", {
			id: "edit_document_FILL0_wght300_GRAD0_opsz48",
			d: "M182.69,231.425A2.719,2.719,0,0,1,180,228.736V198.69A2.719,2.719,0,0,1,182.69,196h15.489l9.788,9.788v6.949h-2.115v-5.55h-9.071v-9.071H182.69a.617.617,0,0,0-.574.574v30.046a.617.617,0,0,0,.574.574h11.975v2.115Zm-.574-2.115v0Z",
			transform: "translate(1232.999 345.998)"
		})]
	})
});
export default SvgPageSettings;
